import { render } from "./DetailRoomList.vue?vue&type=template&id=0910e283&scoped=true"
import script from "./DetailRoomList.vue?vue&type=script&lang=js"
export * from "./DetailRoomList.vue?vue&type=script&lang=js"

import "./DetailRoomList.vue?vue&type=style&index=0&id=0910e283&lang=stylus&scoped=true"
import "./DetailRoomList.vue?vue&type=style&index=1&id=0910e283&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0910e283"]])

export default __exports__